<template>
  <div>
    <h4>CAROUSEL</h4>
    <div
      v-for="(imgField,index) in columns"
      :key="index"
      class="img-row">
      <v-row>
        <v-col
          class="d-flex align-center justify-center"
          cols="5">
          <div class="preview-container-carousel">
            <div class="img-container">
              <img
                :src="`${imgField.imgUrl}/1040`"
                class="img-preview">
            </div>
          </div>
        </v-col>
        <v-col>
          <validation-provider
            v-slot="{ errors }"
            name="ข้อความ"
            rules="required">
            <v-text-field
              v-model="imgField.description"
              label="ข้อความ"
              :readonly="!editable"
              :error-messages="errors[0]"
              @input="returnValue()" />
          </validation-provider>
          <validation-provider
            v-slot="{ errors }"
            name="Action"
            rules="required">
            <v-text-field
              v-model="imgField.action"
              label="Action"
              :readonly="!editable"
              :error-messages="errors[0]"
              @input="returnValue()" />
          </validation-provider>
          <validation-provider
            v-slot="{ errors }"
            name="URL"
            :rules="{regex: /^https:\/\//, required: true}">
            <v-text-field
              v-model="imgField.actionUri"
              label="URL"
              :readonly="!editable"
              :error-messages="errors[0]"
              @input="returnValue()" />
          </validation-provider>
        </v-col>
        <v-col>
          <div class="last-action-column">
            <validation-provider
              v-slot="{ errors }"
              name="ราคาเต็ม"
              rules="numeric|required">
              <v-text-field
                v-model="imgField.fullPrice"
                label="ราคาเต็ม"
                :readonly="!editable"
                :error-messages="errors[0]"
                @input="returnValue()" />
            </validation-provider>
            <validation-provider
              v-slot="{ errors }"
              name="ราคาหลังลด"
              rules="numeric">
              <v-text-field
                v-model="imgField.salePrice"
                label="ราคาหลังลด"
                :readonly="!editable"
                :error-messages="errors[0]"
                @input="returnValue()" />
            </validation-provider>
            <v-btn
              block
              color="error"
              @click="removeColumn(index)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-divider />
      </v-row>
    </div>
    <div
      v-if="columns.length < imgLimit && editable"
      class="upload-container ma-4">
      <validation-provider
        v-slot="{ errors }"
        name="IMG"
        rules="size:10000">
        <upload-file
          accept="image/png, image/jpeg, image/jpg"
          @input="uploadImgHandle" />
        <div class="text-caption text-center mt-2">
          {{ errors[0] || '1040px Recommend' }}
        </div>
      </validation-provider>
    </div>
  </div>
</template>

<script>
import UploadFile from '@/components/form/UploadFile.vue'

export default {
  components: {
    UploadFile
  },
  props: {
    editable: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    columns: [],
    imgLimit: 10
  }),
  methods: {
    uploadImgHandle (img) {
      const baseUrl = `${process.env.VUE_APP_S3_URL}${img[0].Key.replace('/240', '')}`
      this.addNewColumn(baseUrl)
    },
    addNewColumn (imgUrl) {
      this.columns.push({
        imgUrl,
        description: '',
        action: '',
        actionUri: '',
        fullPrice: 0,
        salePrice: 0
      })
    },
    removeColumn (index) {
      this.columns.splice(index, 1)
      this.returnValue()
    },
    returnValue () {
      this.$emit('input', this.columns)
    }
  }
}
</script>

<style scoped>
.column-delete-btn {
  position: absolute;
  top: -5px;
  right: 15px;
}
.last-action-column {
  position: relative;
}
.upload-container {
  width: 20%;
  height: 168px;
}

.preview-container-carousel {
  width: 100%;
  height: 168px;
  position: relative;
}

.preview-container-carousel input {
  font-size: 12px;
}

.preview-container-carousel .img-container {
  display: flex;
  justify-content: center;
  max-height: 168px;
}

.preview-container-carousel .img-preview {
  max-width: 272px;
  align-self: center;
  max-height: 220px;
}

.img-row {
  width: 100%;
  margin: 16px;
}
</style>
